import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { flex, rem } from '../../core';

const modifiers = {
  active: () => ({
    styles: `
      .HamburgerButton__Inner {
        &:before, &:after { opacity: 0; }
        &:before { top: -5px; }
        &:after { bottom: -5px; }
        span:before { transform: rotate(45deg); }
        span:after { transform: rotate(-45deg); }
      }
    `,
  }),
};

export const HamburgerButtonStyled = styled.button.attrs({
  className: 'component__HamburgerButton',
})`
  background: none;
  width: ${rem(30)};
  height: ${rem(30)};
  padding: 0;
  position: relative;
  ${flex('row', 'center', 'center')};
  border: none;
  outline: none;
  cursor: pointer;
  span {
    font-size: 0;
    text-indent: -9999px;
  }
  ${applyStyleModifiers(modifiers)};
`;

export const HamburgerButtonInner = styled.div.attrs({
  className: 'HamburgerButton__Inner',
})`
  width: ${rem(20)};
  height: ${rem(20)};
  position: relative;
  ${flex('column', 'space-between', '')};

  &:before,
  &:after,
  span:before,
  span:after {
    content: '';
    background-color: ${(props) => props.theme.greyDark3};
    width: 100%;
    height: ${rem(2)};
    border-radius: 15px;
    display: block;
    opacity: 1;
    position: absolute;
    transition: ease-in-out all .25s;
    cursor: pointer;
  }
  &:before { top: 9%; }
  &:after { bottom: 9%; }
  span:before,
  span:after {
    top: 50%;
    transform: translateY(-50%);
  }
`;
